import type { Appearance } from '@clerk/types'

export const AUTH_CLERK_APPEARANCE: Appearance = {
  elements: {
    rootBox: 'mx-auto !max-w-full',
    cardBox: '!shadow-none !rounded-none',
    card: '!shadow-none !border-none !bg-transparent',
    footer: '!bg-none !bg-transparent',
    socialButtonsBlockButton: '!border-2 !border-solid !border-gray-300 !shadow-none',
    formFieldInput: '!border-2 !border-solid !border-gray-300 !shadow-none',
  },
}
